export function upsert<T>(array: T[], item: T, key: keyof T): T[] {
  const index = array.findIndex((i) => i[key] === item[key]);
  if (index === -1) return [...array, item];
  array[index] = item;
  return array;
}
